import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

  /*----------------------Global settings---------------------*/
  #root, body, html, label {
    font-family: ${(props) => props.theme.fontFamily1 || 'Poppins Regular'}; 
  }

  .btn-global {
    background-color: ${(props) => props.theme.secondary} !important;
    color: ${(props) => props.theme.dark} !important;
  }

  .text-small{
    color: ${(props) => props.theme.contrastActiveColor} !important;
  }

  .classic-link{
    color: ${(props) => props.theme.primary}!important;
  }

  a.classic-link {
    color: ${(props) => props.theme.primary} !important;
  }

  /*----------------------------Login-------------------------*/

  .home-logo {
    max-width: ${(props) => props.theme.logoSize} !important;
  }
  
  .home-content {
    background: ${(props) => props.theme.activeColor} !important;
    label {
      color: ${(props) => props.theme.contrastActiveColor} !important;
    }
  }

  .home-img {
    background: url(${(props) => props.theme.background}) no-repeat left bottom ;
    background-size: cover;
  }
  .navbar-logo {
    .badge-appenv {
      margin-top: ${(props) => props.theme.badgeMarginTop};
    }
  }
  .home-welcome {
    flex-basis: ${(props) => props.theme.homeWelcomeFb || '15%'}; 
    h1 {
      color: ${(props) => props.theme.h1.color || props.theme.h1} !important;
      font-size: ${(props) => props.theme.h1.fontSize || '24px'}; 
      line-height: ${(props) => props.theme.h1.lineheight || '1.27'}; 
      font-family: ${(props) => props.theme.h1.fontFamily || 'Poppins Bold'}; 
    }
    .badge-appenv {
        margin-top: -10px;
        padding: 0.45em .4em;
        font-size: 10px;
        margin-left: 6px;
    }
  }

  .btn-blue {
    color: ${(props) => props.theme.loginButtonSubmitColor} !important; 
    background-color: ${(props) => props.theme.loginButtonSubmitBackgroundColor}; 
    border-color: ${(props) => props.theme.loginButtonSubmitBorderColor}; 
    width: ${(props) => props.theme.loginButtonSubmitBorderwidth}; 
  }

  button[type='submit'].btn-blue:focus {
    color: ${(props) => props.theme.loginButtonSubmitFocusColor} !important; 
  }

  .login-inputs {
    width: ${(props) => props.theme.loginInputsWidth};
  }

  .forgot-password {
    font-size: ${(props) => props.theme.forgotPasswordFontSize};
  }

  /*---------------------------Panel & Signup-------------------------*/

  .default-navbar {
      &.collapsed {
        .default-navbar-brand {
          background: ${(props) => props.theme.primeraryActive} !important;
        }
      }
  }

  .rounded-title {
    background-color: ${(props) => props.theme.contrastActiveColor};
  }
  
  .text-small{
    color: ${(props) => props.theme.contrastActiveColor} !important;
  }

  .rounded-title-grey {
    background-color: ${(props) => props.theme.roundedGrey} !important;
  }

  .signup-title {
    display: ${(props) => props.theme.displaySignupTitle} !important;
    width: ${(props) => props.theme.logoSize} !important;
  }

  .signup-title > h3 {
    color: ${(props) => props.theme.tupayColor} !important;
  }

  .signup-background {
    background: url(${(props) => props.theme.backgroundSignup}) no-repeat left bottom ;
  }

  .logo-container .logo {
    max-width: ${(props) => props.theme.logoSize} !important;
  }

  #loader {
    border-top-color: ${(props) => props.theme.loaderFirst};
  }

  #loader:before {
    border-top-color: ${(props) => props.theme.loaderSecond};
  }

  #loader:after {
    border-top-color:${(props) => props.theme.loaderThird};
  }

  #loader-with-text {
    border-top-color: ${(props) => props.theme.loaderFirst};
  }

  #loader-with-text:before {
    border-top-color: ${(props) => props.theme.loaderFirst};
  }

  #loader-with-text:after {
    border-top-color: ${(props) => props.theme.loaderSecond};
  }

  #password-span-icon{
    color: ${(props) => props.theme.primary};
  }

  .btn-dark {
    color:  ${(props) => props.theme.buttonDarkColor} !important;
  }

  *::-webkit-input-placeholder {
    font-family: ${(props) => props.theme.fontFamily4} !important;
  }
  
  *:-moz-placeholder {
    /* FF 4-18 */
    font-family: ${(props) => props.theme.fontFamily4} !important;
  }
  *::-moz-placeholder {
    /* FF 19+ */
    font-family: ${(props) => props.theme.fontFamily4} !important;
  }
  *:-ms-input-placeholder {
    /* IE 10+ */
    font-family: ${(props) => props.theme.fontFamily4} !important;
  }

  .input-group.default-input-group
  .form-control.is-invalid + .input-group-append
  .input-group-text,
  .input-group.default-input-group
  .settlement-details__modal-content textarea.is-invalid +
  .input-group-append .input-group-text, .settlement-details__modal-content .input-group.default-input-group textarea.is-invalid + .input-group-append .input-group-text {
    color: ${(props) => props.theme.inputColor}; 
  }

  .__react_component_tooltip {
    padding: 0px !important;
    border-radius: 4px !important;
  }
  

  .default-navbar.collapsed .default-navbar-brand {
  background-color: ${(props) => props.theme.primary} !important;
}

.faqs-icon:hover{
  border: 2px solid ${(props) => props.theme.primary} !important;
}

`;
